<div class="wrap">
    <div class="validation">
        <div class="validation_content">
            <div class="check">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
            </div>
        </div>
        <p>{{text}}</p>
    </div>
</div>